import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ImagesModule } from 'lib/images/images.module.js';
import { TypographyModule } from 'lib/typography/index.js';
import { ButtonModule } from '../buttons/index.js';
import { CardModule } from '../card/index.js';
import { DialogModule } from '../dialog/index.js';
import { DividerModule } from '../divider/index.js';
import { AppFlexModule } from '../flex/index.js';
import { FormInputsModule } from '../form-inputs/form-inputs.module';
import { FormModule } from '../form/form.module.js';
import { IconModule } from '../icons/icon.module.js';
import { LinkModule } from '../link/link.module.js';
import { ListModule } from '../list/list.module';
import { MessagesModule } from '../messages/index.js';
import { ScheduleComponent } from './schedule.component.js';

@NgModule({
	declarations: [ScheduleComponent],
	exports: [ScheduleComponent],
	imports: [
		MessagesModule,
		CommonModule,
		RouterModule,
		ButtonModule,
		CardModule,
		TypographyModule,
		DialogModule,
		AppFlexModule,
		DividerModule,
		LinkModule,
		IconModule,
		ImagesModule,
		FormModule,
		FormInputsModule,
		ListModule
	]
})
export class ScheduleModule {}
